import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import Wrapper from 'common/navigation/wrapper';
import MainMenu from 'common/navigation/containers/main-menu-container';
import TicketFormDetailContainer from '../form/ticket-form-detail-container';

const TicketDetail = ({ match }) => {
  const id = match.params.ticketFullId || match.params.ticketId;
  const renderMenu = (actionButtons = null) =>
    <MainMenu
      id={id}
      type='ticket'
      actionButtons={actionButtons}
    />;

  return (
    <Wrapper>
      <Routes>
        <Route
          path={'details/*'}
          element={<TicketFormDetailContainer
            fullPage={true}
            renderMenu={renderMenu}
            match={match}
            ticketFullId={match.params.ticketFullId}
            ticketId={match.params.ticketId}
            objectId={match.params.objectId}
          />
          }
        />
        <Route
          path='*'
          element={<Navigate to='details' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};
TicketDetail.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(TicketDetail);
